import clsx from "clsx";
import { Box, TextField } from "@mui/material";
import { useStyles } from "../styles";
import CustomBadge from "./Badge";

const CustomTextField = ({ handlePlayerScore, index, player, item, value }) => {
  const classes = useStyles();

  return (
    <Box
      sx={{
        // border: item?.hasBenefit && "1px dotted green",
        padding: "1px 0px",
        width: "36px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: "0 auto",
        position: 'relative',
      }}
    >
      <TextField
        hiddenLabel
        variant="outlined"
        size="small"
        value={value}
        onChange={(e) =>
          handlePlayerScore(e.target.value, index + 1, player, item?.hasBenefit)
        }
        inputProps={{ maxLength: 2 }}
        className={clsx(classes.outlineInputBorder, classes.outlineInput)}
      />
    </Box>
  );
};

export default CustomTextField;
